export default __webpack_public_path__ + "assets/images/others/03c9f687266a6d2480713222c1e05270.png";